<template>
  <div>
    <ejs-grid ref='grid' :dataSource="data" height="140" :rowSelected='getChooseCount' :allowReordering='true' :allowResizing='true' :selectedRowIndex='selectedRowIndex'>
      <e-columns>
        <e-column field='state' :headerText='$t("Spectrum.ui_pt_taskstatus")' textAlign='Center' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter="statusFormat"></e-column>
        <e-column field='starttime' :headerText='$t("Spectrum.ui_pt_starttime")' clipMode='EllipsisWithTooltip' textAlign='Center' type='date' format='yyyy-MM-dd HH:mm:ss'></e-column>
        <e-column field='endtime' :headerText='$t("Spectrum.ui_pt_endtime")' clipMode='EllipsisWithTooltip' textAlign='Center' type='date' format='yyyy-MM-dd HH:mm:ss'></e-column>
        <e-column field='neid' :headerText='$t("Spectrum.ui_pt_enodebid")' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
        <e-column field='cellid' :headerText='$t("Spectrum.ui_pt_cell")' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
        <e-column field='timer' :headerText='$t("Spectrum.ui_pt_spectrumcycle")' clipMode='EllipsisWithTooltip' textAlign='Center' :formatter='cycleFormat'></e-column>
        <e-column field='oper' :headerText='$t("Spectrum.ui_oper")' clipMode='EllipsisWithTooltip' textAlign='Center' :template='operButton'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
import SpectrumTaskOperButton from './SpectrumTaskOperButton';
import socketInstance from '../../../plugins/stompSock';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'SpectrumTable',
  props: ['selectRecord'],
  data() {
    return {
      selectedRowIndex: 0,
      defaultRowSpectrumid: 0,
      firstTableData: false,
      data: {},
      neId: '',
      cellid: '',
      spectrumId: '',
      payload: [
        { topic: '/user/#/SpectrumServer', clientId: '', callback: this.subscribeCallback }
      ],
      TaskCode: {
        ADD_SUCCESS: 0,
        ADD_FAILD: 1,
        STOP_SUCCESS: 2,
        STOP_FAILD: 3,
        RESP_FAILD: 4,
        UNKNOWERROR: 5,
        NORMAL: 6
      }
    };
  },
  methods: {
    getGridData() {
      const $this = this;
      // $this.info.neid = $this.selectRecord.data.neId;
      // $this.info.cellid = $this.selectRecord.data.id;
      // $this.info.netype = ne.data.neType;
      // $this.info.neversion = ne.data.neVersion;
      this.$axios.get(`/lte/ems/spectrum/selectSpectrumRecords.html?neId=${$this.neId}&cellId=${$this.cellid}`).then((response) => {
        const res = response.data;
        if (res.errorCode === 'SUCCESS') {
          $this.data = res.resultVal;
          if (res.resultVal.length === 0) {
            this.setCharDatas(null, null);
          } else {
            $this.defaultRowSpectrumid = res.resultVal[0].id;
            $this.firstTableData = true;
            $this.$refs.grid.selectRow(0);
          }
        } else {
          // alert(this.$t(res.errorCode));
          EventBus.$emit('toast', { type: 'warning', content: this.$ts(`Spectrum.${response.data.errorCode}`) });
        }
      });
    },
    getParams() {
      const $this = this;
      let qryParams = null;
      qryParams = {
        neId: $this.neId,
        cellid: $this.cellid
      };
      return qryParams;
    },
    setCharDatas(spectrumId, datas) {
      this.$parent.$parent.$refs.spectrumChart.setDatas(this.neId, spectrumId, datas);
    },
    getChooseCount(args) {
      console.log('choose count ');
      this.neId = this.$parent.$parent.$refs.leftPanelSpectrum.$children[2].info.neId;
      const selectTask = args.data;
      if (this.firstTableData) {
        this.spectrumId = this.defaultRowSpectrumid;
        this.firstTableData = false;
      } else {
        this.spectrumId = selectTask.id; // 订阅主题
      }
      const params = {
        // neid: selectTask.neId,
        neid: this.neId,
        id: this.spectrumId
      };
      const spectrum = {
        spectrum: params
      };
      // lte/ems/spectrum/selectSpectrumDatas.html
      this.$axios.post('/lte/ems/spectrum/selectSpectrumDatas.html', params).then((response) => {
        if (response.data.errorCode === 'SUCCESS') {
          this.setCharDatas(params.id, response.data.resultVal);
        }
      });
      // 执行中的任务才有数据进行前端的推送
      if (selectTask.state === 3) {
        this.websocketConnect();
      }
    },
    operButton() {
      return {
        template: SpectrumTaskOperButton
      };
    },
    cycleFormat(grids, data) {
      if (data.timer === 0) {
        return `${this.$t('Spectrum.ui_pt_spectrum1s')}`;
      }
      if (data.timer === 1) {
        return `${this.$t('Spectrum.ui_pt_spectrum2s')}`;
      }
      if (data.timer === 2) {
        return `${this.$t('Spectrum.ui_pt_spectrum5s')}`;
      }
      if (data.timer === 3) {
        return `${this.$t('Spectrum.ui_pt_spectrum10s')}`;
      }
      return `${this.$t('Spectrum.ui_pt_spectrum10s')}`;
    },
    statusFormat(grids, data) {
      if (data.state === 0) {
        return `<span class='h-spectrumtaskstatus${data.state}'>${this.$t('Spectrum.ui_pt_taskstatus_waiting')}</span>`;
      }
      if (data.state === 1) {
        return `<span class='h-spectrumtaskstatus${data.state}'>${this.$t('Spectrum.ui_pt_taskstatus_submit')}</span>`;
      }
      if (data.state === 2) {
        return `<span class='h-spectrumtaskstatus${data.state}'>${this.$t('Spectrum.ui_pt_taskstatus_failed')}</span>`;
      }
      if (data.state === 3) {
        return `<span class='h-spectrumtaskstatus${data.state}'>${this.$t('Spectrum.ui_pt_taskstatus_execute')}</span>`;
      }
      if (data.state === 4) {
        return `<span class='h-spectrumtaskstatus${data.state}'>${this.$t('Spectrum.ui_pt_taskstatus_stop')}</span>`;
      }
      if (data.state === 5) {
        return `<span class='h-spectrumtaskstatus${data.state}'>${this.$t('Spectrum.ui_pt_taskstatus_end')}</span>`;
      }
      return `<span class='h-spectrumtaskstatus${data.state}'>${this.$t('Spectrum.ui_pt_taskstatus_waiting')}</span>`;
    },
    websocketConnect() {
      const oldClientId = this.payload[0].clientId;
      this.payload[0].clientId = this.spectrumId;
      if (socketInstance.stompClient == null) {
        socketInstance.init(this.payload);
      } else {
        if (oldClientId !== '') {
          socketInstance.stopReceiveTopicMsg(oldClientId, '/user/#/SpectrumServer');
        }
        socketInstance.dynamicSubscribe('/user/#/SpectrumServer', this.spectrumId, this.subscribeCallback);
      }
    },
    subscribeCallback(msg) {
      // console.log(msg);
      const data = JSON.parse(msg.body);
      const resultVal = data.resultVal.result;
      const response = data.resultVal.responseData;
      const spectrum = data.resultVal.requestData;　
      if (resultVal === this.TaskCode.ADD_SUCCESS || resultVal === this.TaskCode.STOP_SUCCESS) {
        this.getGridData();
      } else {
        this.$parent.$parent.$refs.spectrumChart.addData(spectrum.id, response);
      }
    }
  },
  created() {
    EventBus.$on('spectrumTaskRefresh', target => {
      this.getGridData();
    });
  }
};
</script>

<style scoped>

</style>
